export interface Naciones {
    Pais: string;
    CodigoTelefono: string;
}

export class FormatoTelefono {
    Numero: string;
    CodigoTelefono: string;
}

export enum CodTelefono {
    COD_TELEFONO_DEFAULT = '+34'
}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/naciones.ts